/**
 * Generated from ch3_p01.fla
 */
export function ch3_p01(this: Ich3_p01) {
	const bg = this.bg;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const bedMessy = this.bedMessy;
	ch3_p01_hh_ch3_72dpi_p01psdAssetBedMessy.call(this.bedMessy);
	bedMessy.x = 608;
	bedMessy.y = 491.25;
	bedMessy.width = 748.00;
	bedMessy.height = 413.50;
	bedMessy.alpha = 1.00;
	if (bedMessy.onLayout) bedMessy.onLayout();
	const bedClean = this.bedClean;
	ch3_p01_hh_ch3_72dpi_p01psdAssetBedClean.call(this.bedClean);
	bedClean.x = 608;
	bedClean.y = 491.25;
	bedClean.width = 748.00;
	bedClean.height = 413.50;
	bedClean.alpha = 1.00;
	if (bedClean.onLayout) bedClean.onLayout();
	const nightStand = this.nightStand;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_nightstand.call(this.nightStand);
	nightStand.x = 280.75;
	nightStand.y = 538.75;
	nightStand.width = 228.50;
	nightStand.height = 376.50;
	nightStand.alpha = 1.00;
	if (nightStand.onLayout) nightStand.onLayout();
	const clothes = this.clothes;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_clothes.call(this.clothes);
	clothes.x = 1256.5;
	clothes.y = 317;
	clothes.width = 153.00;
	clothes.height = 197.00;
	clothes.alpha = 1.00;
	if (clothes.onLayout) clothes.onLayout();
	const floorItems = this.floorItems;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_flooritems.call(this.floorItems);
	floorItems.x = 1079.5;
	floorItems.y = 687.75;
	floorItems.width = 173.00;
	floorItems.height = 112.50;
	floorItems.alpha = 1.00;
	if (floorItems.onLayout) floorItems.onLayout();
	const holly = this.holly;
	ch3_p01_hh_ch3_72dpi_p01psdAssetHollychoreslist.call(this.holly);
	holly.x = 1052;
	holly.y = 674.5;
	holly.width = 152.00;
	holly.height = 523.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const basket = this.basket;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basket.call(this.basket);
	basket.x = 458;
	basket.y = 768;
	basket.width = 373.00;
	basket.height = 162.00;
	basket.alpha = 1.00;
	if (basket.onLayout) basket.onLayout();
	const basketLidOff = this.basketLidOff;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidoff.call(this.basketLidOff);
	basketLidOff.x = 610.25;
	basketLidOff.y = 755;
	basketLidOff.width = 91.50;
	basketLidOff.height = 296.00;
	basketLidOff.alpha = 1.00;
	if (basketLidOff.onLayout) basketLidOff.onLayout();
	const basketLidOn = this.basketLidOn;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidon.call(this.basketLidOn);
	basketLidOn.x = 492.5;
	basketLidOn.y = 646.75;
	basketLidOn.width = 296.00;
	basketLidOn.height = 91.50;
	basketLidOn.alpha = 1.00;
	if (basketLidOn.onLayout) basketLidOn.onLayout();
	const list = this.list;
	ch3_p01_hh_ch3_72dpi_p02psdAssetchp3_p02_list.call(this.list);
	list.x = 833.5;
	list.y = 395.25;
	list.width = 638.00;
	list.height = 713.50;
	list.alpha = 1.00;
	if (list.onLayout) list.onLayout();
	const frameRight = this.frameRight;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesRight = this.linesRight;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartL.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 312.75;
	linesRight.width = 157.50;
	linesRight.height = 625.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const linesLeft = this.linesLeft;
	ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartR.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 384;
	linesLeft.width = 115.50;
	linesLeft.height = 768.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_bg(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_bg.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetBedMessy(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetBedMessy) {
	if (this.setLayoutTexture) this.setLayoutTexture("BedMessy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetBedClean(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetBedClean) {
	if (this.setLayoutTexture) this.setLayoutTexture("BedClean", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_nightstand(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_nightstand) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_nightstand", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_clothes(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_clothes) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_clothes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_flooritems(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_flooritems) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_flooritems", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetHollychoreslist(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetHollychoreslist) {
	if (this.setLayoutTexture) this.setLayoutTexture("Hollychoreslist", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basket(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basket) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basket", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidoff(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidoff) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basketlidoff", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidon(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidon) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p01_basketlidon", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p02psdAssetchp3_p02_list(this: Ich3_p01_hh_ch3_72dpi_p02psdAssetchp3_p02_list) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p02_list", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameR(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameR) {
	if (this.setLayoutTexture) this.setLayoutTexture("FrameR", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameL(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameL) {
	if (this.setLayoutTexture) this.setLayoutTexture("FrameL", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartL(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartL) {
	if (this.setLayoutTexture) this.setLayoutTexture("LineartL", 1.000, 0.501);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartR(this: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartR) {
	if (this.setLayoutTexture) this.setLayoutTexture("LineartR", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich3_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich3_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich3_p01Sprite extends Ich3_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich3_p01Text extends Ich3_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich3_p01Polygon extends Array<number> {
}
interface Ich3_p01 {
	readonly bg: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_bg;
	readonly bedMessy: Ich3_p01_hh_ch3_72dpi_p01psdAssetBedMessy;
	readonly bedClean: Ich3_p01_hh_ch3_72dpi_p01psdAssetBedClean;
	readonly nightStand: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_nightstand;
	readonly clothes: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_clothes;
	readonly floorItems: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_flooritems;
	readonly holly: Ich3_p01_hh_ch3_72dpi_p01psdAssetHollychoreslist;
	readonly basket: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basket;
	readonly basketLidOff: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidoff;
	readonly basketLidOn: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidon;
	readonly list: Ich3_p01_hh_ch3_72dpi_p02psdAssetchp3_p02_list;
	readonly frameRight: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameR;
	readonly frameLeft: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameL;
	readonly linesRight: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartL;
	readonly linesLeft: Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartR;
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_bg extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetBedMessy extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetBedClean extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_nightstand extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_clothes extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_flooritems extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetHollychoreslist extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basket extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidoff extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_basketlidon extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p02psdAssetchp3_p02_list extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameR extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeFrameL extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartL extends Ich3_p01Sprite {
}
interface Ich3_p01_hh_ch3_72dpi_p01psdAssetchp3_p01_wcframeLineartR extends Ich3_p01Sprite {
}
